import React from 'react';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import { paths } from '@/app/paths';
import { FormFieldConfigsPage } from './FormFieldConfigsPage';

export const formFieldConfigsRoutes = [
	{
		path: 'client-config',
		element: <FormFieldConfigsPage />,
		handle: { title: 'Client config', icon: <TuneOutlinedIcon /> },
	},
];

export const formFieldConfigsNavItem = {
	text: 'Client config',
	icon: <TuneOutlinedIcon sx={{ fontSize: 30 }} />,
	link: `${paths.admin}/client-config`,
};
